import isV5ChartDef from './isV5ChartDef';

const isScorecard = (
  def?: ExtendedVisualisationDefinition,
): def is Scorecards.Scorecard => {
  if (isV5ChartDef(def)) {
    return false;
  }

  return !!def && def.type === 'Scorecard';
};

export default isScorecard;
